import React from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

import ExceedGroupsCustomListItem from './exceedGroupsCustomListItem';

import styles from '../styles/groupsEligibleMembers.module.scss';

const GroupsEligibleMembers = ({
  members, type, shouldShowEmptyState, emptyStateText,
}) => (
  <div className={styles.element}>
    {shouldShowEmptyState ? (
      <Typo className={styles.emptyText} varaint="b01" weight="medium">{emptyStateText}</Typo>
    ) : (
      <ul className={styles.listWrap}>
        {members.map((member) => {
          const {
            id, name, code, avatar, metadata,
          } = member;
          return (
            <ExceedGroupsCustomListItem
              className={styles.listItem}
              key={id}
              hasButton={false}
              selectedItem={{
                id, name, code, avatar, jobTitle: metadata.job_title, type,
              }}
            />
          );
        })}
      </ul>
    )}
  </div>
);

GroupsEligibleMembers.defaultProps = {
  type: '',
  emptyStateText: '',
  shouldShowEmptyState: false,
  members: [],
};

GroupsEligibleMembers.propTypes = {
  type: PropTypes.string,
  emptyStateText: PropTypes.string,
  shouldShowEmptyState: PropTypes.bool,
  members: PropTypes.arrayOf(PropTypes.shape({})),
};

export default React.memo(GroupsEligibleMembers);
